import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";

const SITE_URL = "https://ladimoradipatty.it";
const OG_IMAGE = "https://customer-assets.emergentagent.com/job_premium-retreats-3/artifacts/isgewiz6_castel-di-sangro-hd.jpg";

const setMeta = (name, content, attr = "name") => {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href, hreflang = null) => {
  const selector = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]:not([hreflang])`;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    if (hreflang) el.setAttribute("hreflang", hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

/**
 * Simple SEO hook — updates title, description, canonical, OG, hreflang on page navigation.
 */
export const useSEO = ({ title, description, keywords }) => {
  const { pathname } = useLocation();
  const { lang } = useLang();

  useEffect(() => {
    const fullUrl = `${SITE_URL}${pathname}`;
    const brandedTitle = title ? `${title} — La dimora di Patty` : "La dimora di Patty — Casa vacanza · Castel di Sangro";

    document.title = brandedTitle;
    setMeta("description", description);
    if (keywords) setMeta("keywords", keywords);

    // Canonical
    setLink("canonical", fullUrl);

    // hreflang alternates (same URL, ?lang=en param convention)
    setLink("alternate", fullUrl, "it");
    setLink("alternate", `${fullUrl}?lang=en`, "en");
    setLink("alternate", fullUrl, "x-default");

    // Open Graph
    setMeta("og:title", brandedTitle, "property");
    setMeta("og:description", description, "property");
    setMeta("og:url", fullUrl, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:image", OG_IMAGE, "property");
    setMeta("og:locale", lang === "en" ? "en_GB" : "it_IT", "property");
    setMeta("og:site_name", "La dimora di Patty", "property");

    // Twitter
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", brandedTitle);
    setMeta("twitter:description", description);
    setMeta("twitter:image", OG_IMAGE);
  }, [pathname, lang, title, description, keywords]);
};
